<template>
    <div class="ah-page accounting-yearly-excluded-voucher-list-page">
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <el-button type="dark-transparent" icon="el-icon-back" @click="$router.push({ name: 'accounting-yearly-management' })"> 回年度作業 </el-button>
                        <h1 style="vertical-align: middle; margin-left: 15px;">{{ taiwanYear }} 年度未列入傳票清單</h1>
                    </div>
                    <div class="actions">
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="margin-top: 20px">
            <div class="ah-container">
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">在報表鎖定後產生的傳票、未列入當前報表計算（共 {{ datas.length }} 張）。</div>
                    </div>
                    <div class="panel-body" style="padding: 30px 50px 50px 50px">
                        <el-button type="primary" size="small" :disabled='!selectedItems.length' @click="onIncorporateConfirmDialogOpen">列入{{ taiwanYear }}年報表({{ selectedItems.length }})</el-button>
                        <ah-sticky-el-table-header>
                            <el-table v-loading="isLoading" :data="datas" ref="table" empty-text="沒有資料" @row-click="onRowClick" @selection-change="onSelectChange" class="row-click">
                                <el-table-column type="selection" width="42" key="checkbox"> </el-table-column>
                                <el-table-column prop="serialNumber" label="傳票號碼" width="120" />
                                <el-table-column prop="dat" label="傳票日期" width="100">
                                    <template slot-scope="scope">
                                        <div>{{ getChineseDate(scope.row.dat) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="傳票狀態" width="80">
                                    <template slot-scope="scope">
                                        <ah-voucher-status-label :status="scope.row.status" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="transactionType" label="帳務類型">
                                    <template slot-scope="scope">
                                        <span v-if="!scope.row.includeInReport" class="not-included-label">未列入報表</span>
                                        {{ transactionTypeToName(scope.row) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="crD_NTD" label="借方金額" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.crD_NTD" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="deB_NTD" label="貸方金額" align="right">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.deB_NTD" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </ah-sticky-el-table-header>
                    </div>
                </div>
            </div>
        </div>
        <VoucherDetail
            ref="voucherDetail"
            :visible="voucherDetail.visible"
            :vono="voucherDetail.vono"
            :QueryType="voucherDetail.queryType"
            @close="onVoucherDetailCLose"
            @duplicate="onVoucherDuplicate"
        />
        <IncorporateConfirmDialog
            :visible="incorporateConfirmDialog.visible"
            :lastSettlementBelongDate="lastSettlementBelongDate"
            :selectedItems="selectedItems"
            :year="+$route.params.year"
            @close="onIncorporateConfirmDialogClose"
        />
    </div>
</template>

<script>
import moment from 'moment';
import ahStickyElTableHeader from '@/components/ui/ahStickyElTableHeader.vue';
import VoucherDetail from '@/components/dashboard/Accounting/AccountingVoucherList/ui/VoucherDetail.vue';
import { transactionType } from '@/assets/commonData/options';
import ahVoucherStatusLabel from '@/components/ui/ahVoucherStatusLabel.vue';
import IncorporateConfirmDialog from '@/components/dashboard/Accounting/AccountingYearlyManagement/IncorporateConfirmDialog.vue';

export default {
    name: 'AccountingYearlyExcludedVoucherListPage',
    components: {
        VoucherDetail,
        ahStickyElTableHeader,
        ahVoucherStatusLabel,
        IncorporateConfirmDialog,
    },
    computed: {
        taiwanYear() {
            return +this.$route.params.year - 1911;
        },
    },
    data() {
        return {
            selectedItems: [],
            transactionType,
            isLoading: false,
            datas: [],

            lastSettlementBelongDate: null,
            queryParams: {
                year: this.$route.params.year,
                PageNum: 1,
                PageSize: 50,
            },
            voucherDetail: {
                visible: false,
                transactionType: null,
                vono: null,
                queryType: null,
            },
            incorporateConfirmDialog: {
                visible: false,
            },
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'AnnualAccountingTask/GetExcludedVoucherList',
                    method: 'GET',
                    params: this.queryParams,
                });
                this.datas = resp.data.items;
                this.lastSettlementBelongDate = resp.data.lastSettlementBelongDate;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        onRowClick(data) {
            this.voucherDetail.visible = true;
            this.voucherDetail.vono = data.vono;
            this.voucherDetail.transactionType = data.transactionType;
        },
        onSelectChange(selected) {
            this.selectedItems = selected;
        },

        getChineseDate(timestamp) {
            const day = moment(timestamp);
            const y = day.year() - 1911;
            const md = day.format('MM-DD');
            return `${y}-${md}`;
        },
        onVoucherDetailCLose(refresh) {
            // if (this.voucherDetail.queryType === 11) this.onAfterEmptyVoucherSubmit();

            this.voucherDetail.visible = false;
            this.voucherDetail.vono = null;
            this.voucherDetail.transactionType = null;
            this.voucherDetail.queryType = null;
            if (refresh) {
                this.updateData();
            }
        },
        onVoucherDuplicate(voucher) {
            const sourceData = JSON.parse(JSON.stringify(voucher));
            this.onVoucherDetailCLose();
            setTimeout(() => {
                this.onAddEmptyVoucher(sourceData);
            }, 10);
        },
        transactionTypeToName(row) {
            if (row.unT_NBR.includes('FORWARD')) return '結帳';
            if (row.unT_NBR.includes('INITIAL')) return '開帳';

            const transaction = this.transactionType.find((t) => t.key === row.transactionType);
            return transaction?.label;
        },

        onIncorporateConfirmDialogOpen() {
            this.incorporateConfirmDialog.visible = true;
        },
        onIncorporateConfirmDialogClose(refresh) {
            this.incorporateConfirmDialog.visible = false;
            if (refresh) this.updateData();
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.accounting-yearly-excluded-voucher-list-page {
    .lock-status {
        font-size: 12px;
    }
    .primary {
        color: $main-color;
    }
    .accounting-report {
        display: flex;
        align-items: center;
        > * {
            &:first-child {
                margin-right: 10px;
            }
            > * {
                font-weight: bold;
            }
        }
    }

    .el-step__title {
        font-size: 14px;
        line-height: 26px;
    }
    .step-description {
        font-size: 10px;
        line-height: 13px;
        margin-top: 4px;
    }
    .not-included-label {
        font-size: 9pt;
        color: red;
        border-radius: 3px;
        border: 1px solid red;
        padding: 3px 6px;
        margin-right: 5px;
    }
}
</style>
